import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Context, Hooks, Util, Request, XtLocale } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer(({ data, callback, stepFunc, isSimple, isHideExpired, className, style }) => {
  const t = useTranslation();
  const { finance } = useStore();

  const isOvertime = useRef(false);

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    const convertData = {
      destTime: data || 0,
    };
    return convertData;
  }, [data]);

  const [nowTime, setNowTime] = useState(Date.now());
  const timeObj = useMemo(() => {
    const distTime = Math.round((selfData.destTime - nowTime) / 1000);
    let leftTime = distTime;
    if (leftTime < 0) {
      leftTime = 0;
    }

    return {
      distTime,
      leftTime,
      day: Math.floor(leftTime / (24 * 60 * 60)),
      hour: Math.floor((leftTime % (24 * 60 * 60)) / (60 * 60)),
      minute: Math.floor((leftTime % (60 * 60)) / 60),
      second: Math.floor((leftTime % 60) / 1),
    };
  }, [nowTime, selfData]);

  useEffect(() => {
    if (!timeObj.leftTime) isOvertime.current = true;
  }, []);
  useEffect(() => {
    if (!selfData.destTime || isOvertime.current) return;
    if (timeObj.distTime < 0) {
      isOvertime.current = true;
      callback && callback();
    }
  }, [selfData, timeObj, callback]);
  useEffect(() => {
    if (timeObj.leftTime > 0 && stepFunc) stepFunc();
  }, [timeObj, stepFunc]);

  const getStr = useCallback((val) => {
    if (val > 9) return val + "";
    return "0" + val;
  }, []);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setNowTime(Date.now());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  if (!selfData.destTime) return;
  if (isHideExpired && selfData.destTime - nowTime < 0) return;
  const isCN = XtLocale.getLangPath() == "zh-CN";
  const D = isCN ? "天" : "D";
  const H = isCN ? "时" : "H";
  const M = isCN ? "分" : "M";
  const S = isCN ? "秒" : "S";
  if (isSimple)
    return (
      <div className={cx(styles.simple, className)} style={style}>
        <div>{getStr(timeObj.day)}</div>
        <span>{D}:</span>
        <div>{getStr(timeObj.hour)}</div>
        <span>{H}:</span>
        <div>{getStr(timeObj.minute)}</div>
        <span>{M}:</span>
        <div>{getStr(timeObj.second)}</div>
        <span>{S}</span>
      </div>
    );

  return (
    <div className={cx(styles.main, className)} style={style}>
      <div>{getStr(timeObj.day)}</div>
      <span>{D}</span>
      <div>{getStr(timeObj.hour)}</div>
      <span>{H}</span>
      <div>{getStr(timeObj.minute)}</div>
      <span>{M}</span>
      <div>{getStr(timeObj.second)}</div>
      <span>{S}</span>
    </div>
  );
});
